import { useMutation } from '@tanstack/react-query';
import { endViewAs } from '@/api/view-as.api';
import { clearAccessToken } from '@/lib/auth/session';
import { API_ERROR_CODES } from '@/lib/constants/error-codes';
import { ROUTES } from '@/lib/constants/routes';
import { getApiErrorCode } from '@/lib/utils/error.utils';

/** Drop this tab's view-as token and leave: close the tab, or show the ended page if the browser keeps it open. */
function leaveViewAs(): void {
  clearAccessToken();
  window.close();
  window.location.assign(ROUTES.VIEW_AS);
}

/**
 * Exit a view-as session (MYN-335): ends it on the Backend, then clears the
 * tab's token and closes the tab. A session that had already ended counts as
 * exited. Any other failure keeps the tab and its banner so Exit can be retried;
 * the banner shows the error inline.
 */
export function useEndViewAs() {
  return useMutation({
    mutationFn: endViewAs,
    onSuccess: leaveViewAs,
    onError: (error) => {
      if (getApiErrorCode(error) === API_ERROR_CODES.VIEW_AS_SESSION_ENDED) leaveViewAs();
    },
  });
}
